/**
 * Dashboard Service
 * Handles all dashboard-related API calls
 *
 * @module services/DashboardService
 */

import BaseService from "core/api/BaseService";

class DashboardService extends BaseService {
  constructor() {
    super("/dashboard");
  }

  async getDashboardData() {
    return this.get("");
  }

  async getTeacherStats() {
    return this.get("teacher/stats");
  }

  async getStudentStats() {
    return this.get("student/stats");
  }
}

export default new DashboardService();
